export default function (app, requireContext, alterComponent) {
    requireContext.keys().forEach(fileName => {
        // Get component config
        let componentConfig = requireContext(fileName);
        componentConfig = componentConfig.default || componentConfig;

        alterComponent && alterComponent(componentConfig);

        const componentName = fileName.split('/').pop().replace(/\.\w+$/, '');

        app.component(componentName, componentConfig);
    });
}